export const PLOT_CLASSIFICATION_TYPES = {
  'Produção Agrícola': 'PA',
  'Produção Pecuária': 'PP',
  'Produção Florestal': 'PF',
  'Preservação Permanente (APP)': 'APP',
  'Reserva Legal (ALR)': 'ALR',
  'Barragem / Lago': 'BL'
}
